import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { PageMask } from "./PageMask";
import "react-toastify/dist/ReactToastify.css";
import { PendingChangesProvider } from "./PendingChangesContext";
import { SaveChangesBar } from "./SaveChangesBar";

export function App() {
  return (
    <div style={{ height: "100vh" }}>
      <PendingChangesProvider>
        <ToastContainer />
        <SaveChangesBar />
        <PageMask />
        <Outlet />
      </PendingChangesProvider>
    </div>
  );
}
